import { render } from "./LMIGeneral.vue?vue&type=template&id=6a7f6fe8"
import script from "./LMIGeneral.vue?vue&type=script&lang=js"
export * from "./LMIGeneral.vue?vue&type=script&lang=js"

import "./LMIGeneral.vue?vue&type=style&index=0&id=6a7f6fe8&lang=css"
script.render = render

export default script